// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "reporting/v1/reporting.proto" (package "reporting.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Internal apis for the reporting service
//
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../google/protobuf/timestamp";
/**
 * @generated from protobuf message reporting.v1.TeleopReportConfig
 */
export interface TeleopReportConfig {
    /**
     * @generated from protobuf field: string workspace_id = 1;
     */
    workspaceId: string;
    /**
     * @generated from protobuf field: string machine_id = 2;
     */
    machineId: string;
}
/**
 * @generated from protobuf message reporting.v1.ReportEntryConfig
 */
export interface ReportEntryConfig {
    /**
     * @generated from protobuf oneof: entry
     */
    entry: {
        oneofKind: "teleopReport";
        /**
         * @generated from protobuf field: reporting.v1.TeleopReportConfig teleop_report = 1;
         */
        teleopReport: TeleopReportConfig; // In the future, will support things like direct MQL queries & org stats
        // (delete this comment when new things are added)
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message reporting.v1.TitlePageConfig
 */
export interface TitlePageConfig {
    /**
     * @generated from protobuf field: string title = 1;
     */
    title: string;
    /**
     * @generated from protobuf field: optional string subtitle = 2;
     */
    subtitle?: string;
    /**
     * @generated from protobuf field: optional bytes logo = 3;
     */
    logo?: Uint8Array;
}
/**
 * @generated from protobuf message reporting.v1.ReportConfig
 */
export interface ReportConfig {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * title_page can be omitted to skip its generation
     *
     * @generated from protobuf field: optional reporting.v1.TitlePageConfig title_page = 2;
     */
    titlePage?: TitlePageConfig;
    /**
     * @generated from protobuf field: repeated reporting.v1.ReportEntryConfig entries = 3;
     */
    entries: ReportEntryConfig[];
}
/**
 * We don't use google.protobuf.Timestamp because different report schedules
 * care about these values independently
 *
 * @generated from protobuf message reporting.v1.ReportScheduleDatetime
 */
export interface ReportScheduleDatetime {
    /**
     * @generated from protobuf field: int32 month_of_year = 1;
     */
    monthOfYear: number;
    /**
     * @generated from protobuf field: int32 day_of_month = 2;
     */
    dayOfMonth: number;
    /**
     * @generated from protobuf field: int32 hour_of_day = 3;
     */
    hourOfDay: number;
    /**
     * @generated from protobuf field: int32 minute_of_hour = 4;
     */
    minuteOfHour: number;
    /**
     * @generated from protobuf field: string timezone = 5;
     */
    timezone: string;
}
/**
 * @generated from protobuf message reporting.v1.ReportScheduleSendOnce
 */
export interface ReportScheduleSendOnce {
    /**
     * @generated from protobuf field: reporting.v1.ReportScheduleDatetime time = 1;
     */
    time?: ReportScheduleDatetime;
}
/**
 * @generated from protobuf message reporting.v1.ReportScheduleDaily
 */
export interface ReportScheduleDaily {
    /**
     * @generated from protobuf field: bool monday_to_friday_only = 1;
     */
    mondayToFridayOnly: boolean;
    /**
     * @generated from protobuf field: reporting.v1.ReportScheduleDatetime start_time = 2;
     */
    startTime?: ReportScheduleDatetime;
    /**
     * @generated from protobuf field: optional reporting.v1.ReportScheduleDatetime end_time = 3;
     */
    endTime?: ReportScheduleDatetime;
}
/**
 * @generated from protobuf message reporting.v1.ReportScheduleWeekly
 */
export interface ReportScheduleWeekly {
    /**
     * @generated from protobuf field: reporting.v1.ReportScheduleDatetime start_time = 2;
     */
    startTime?: ReportScheduleDatetime;
    /**
     * @generated from protobuf field: optional reporting.v1.ReportScheduleDatetime end_time = 3;
     */
    endTime?: ReportScheduleDatetime;
}
/**
 * @generated from protobuf message reporting.v1.ReportScheduleMonthly
 */
export interface ReportScheduleMonthly {
    /**
     * @generated from protobuf field: bool send_on_last_day_of_month = 1;
     */
    sendOnLastDayOfMonth: boolean;
    /**
     * @generated from protobuf field: reporting.v1.ReportScheduleDatetime start_time = 2;
     */
    startTime?: ReportScheduleDatetime;
    /**
     * @generated from protobuf field: optional reporting.v1.ReportScheduleDatetime end_time = 3;
     */
    endTime?: ReportScheduleDatetime;
}
/**
 * equivalent to disabling the report without deleting it
 *
 * @generated from protobuf message reporting.v1.ReportScheduleNever
 */
export interface ReportScheduleNever {
}
/**
 * @generated from protobuf message reporting.v1.ReportSchedule
 */
export interface ReportSchedule {
    /**
     * @generated from protobuf oneof: interval
     */
    interval: {
        oneofKind: "once";
        /**
         * @generated from protobuf field: reporting.v1.ReportScheduleSendOnce once = 1;
         */
        once: ReportScheduleSendOnce;
    } | {
        oneofKind: "daily";
        /**
         * @generated from protobuf field: reporting.v1.ReportScheduleDaily daily = 2;
         */
        daily: ReportScheduleDaily;
    } | {
        oneofKind: "weekly";
        /**
         * @generated from protobuf field: reporting.v1.ReportScheduleWeekly weekly = 3;
         */
        weekly: ReportScheduleWeekly;
    } | {
        oneofKind: "monthly";
        /**
         * @generated from protobuf field: reporting.v1.ReportScheduleMonthly monthly = 4;
         */
        monthly: ReportScheduleMonthly;
    } | {
        oneofKind: "never";
        /**
         * @generated from protobuf field: reporting.v1.ReportScheduleNever never = 5;
         */
        never: ReportScheduleNever;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message reporting.v1.ReportDeliveryConfig
 */
export interface ReportDeliveryConfig {
    /**
     * @generated from protobuf field: string email_subject = 1;
     */
    emailSubject: string;
    /**
     * @generated from protobuf field: string email_body = 2;
     */
    emailBody: string;
    /**
     * @generated from protobuf field: string email_reply_to_address = 3;
     */
    emailReplyToAddress: string;
    /**
     * @generated from protobuf field: repeated string recipient_email_addresses = 4;
     */
    recipientEmailAddresses: string[];
    /**
     * if non-empty, this address will receive an email if the report generation
     * fails, and the report will not be sent to the rest of the recipients
     *
     * @generated from protobuf field: string owner_email_address = 5;
     */
    ownerEmailAddress: string;
}
/**
 * @generated from protobuf message reporting.v1.ScheduledReport
 */
export interface ScheduledReport {
    /**
     * @generated from protobuf field: reporting.v1.ReportConfig config = 1;
     */
    config?: ReportConfig;
    /**
     * @generated from protobuf field: reporting.v1.ReportSchedule schedule = 2;
     */
    schedule?: ReportSchedule;
    /**
     * @generated from protobuf field: reporting.v1.ReportDeliveryConfig delivery = 3;
     */
    delivery?: ReportDeliveryConfig;
}
/**
 * @generated from protobuf message reporting.v1.GenerateReportRequest
 */
export interface GenerateReportRequest {
    /**
     * @generated from protobuf field: reporting.v1.ReportConfig config = 1;
     */
    config?: ReportConfig;
}
/**
 * We do not expect these to be larger than max unary gRPC message size.
 *
 * @generated from protobuf message reporting.v1.GenerateReportResponse
 */
export interface GenerateReportResponse {
    /**
     * @generated from protobuf field: bytes pdf = 1;
     */
    pdf: Uint8Array;
}
/**
 * @generated from protobuf message reporting.v1.CreateScheduledReportRequest
 */
export interface CreateScheduledReportRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
    /**
     * @generated from protobuf field: reporting.v1.ScheduledReport report = 2;
     */
    report?: ScheduledReport;
    /**
     * if true, this will schedule the report to be sent immediately
     *
     * @generated from protobuf field: bool send_now = 3;
     */
    sendNow: boolean;
}
/**
 * @generated from protobuf message reporting.v1.CreateScheduledReportResponse
 */
export interface CreateScheduledReportResponse {
    /**
     * @generated from protobuf field: string report_id = 1;
     */
    reportId: string;
}
/**
 * @generated from protobuf message reporting.v1.UpdateScheduledReportRequest
 */
export interface UpdateScheduledReportRequest {
    /**
     * @generated from protobuf field: string report_id = 1;
     */
    reportId: string;
    /**
     * @generated from protobuf field: reporting.v1.ScheduledReport new_report = 2;
     */
    newReport?: ScheduledReport;
}
/**
 * @generated from protobuf message reporting.v1.UpdateScheduledReportResponse
 */
export interface UpdateScheduledReportResponse {
}
/**
 * @generated from protobuf message reporting.v1.DeleteScheduledReportRequest
 */
export interface DeleteScheduledReportRequest {
    /**
     * @generated from protobuf field: string report_id = 1;
     */
    reportId: string;
}
/**
 * @generated from protobuf message reporting.v1.DeleteScheduledReportResponse
 */
export interface DeleteScheduledReportResponse {
}
/**
 * @generated from protobuf message reporting.v1.GetScheduledReportRequest
 */
export interface GetScheduledReportRequest {
    /**
     * @generated from protobuf field: string report_id = 1;
     */
    reportId: string;
}
/**
 * @generated from protobuf message reporting.v1.GetScheduledReportResponse
 */
export interface GetScheduledReportResponse {
    /**
     * @generated from protobuf field: reporting.v1.ScheduledReport report = 1;
     */
    report?: ScheduledReport;
}
/**
 * @generated from protobuf message reporting.v1.ListReportsItem
 */
export interface ListReportsItem {
    /**
     * @generated from protobuf field: string report_id = 1;
     */
    reportId: string;
    /**
     * @generated from protobuf field: string report_name = 2;
     */
    reportName: string;
    /**
     * @generated from protobuf field: repeated string report_email_addresses = 3;
     */
    reportEmailAddresses: string[];
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_sent_at = 4;
     */
    lastSentAt?: Timestamp;
}
/**
 * @generated from protobuf message reporting.v1.ListScheduledReportsRequest
 */
export interface ListScheduledReportsRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
}
/**
 * @generated from protobuf message reporting.v1.ListScheduledReportsResponse
 */
export interface ListScheduledReportsResponse {
    /**
     * @generated from protobuf field: repeated reporting.v1.ListReportsItem reports = 1;
     */
    reports: ListReportsItem[];
}
// @generated message type with reflection information, may provide speed optimized methods
class TeleopReportConfig$Type extends MessageType<TeleopReportConfig> {
    constructor() {
        super("reporting.v1.TeleopReportConfig", [
            { no: 1, name: "workspace_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "machine_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message reporting.v1.TeleopReportConfig
 */
export const TeleopReportConfig = new TeleopReportConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReportEntryConfig$Type extends MessageType<ReportEntryConfig> {
    constructor() {
        super("reporting.v1.ReportEntryConfig", [
            { no: 1, name: "teleop_report", kind: "message", oneof: "entry", T: () => TeleopReportConfig }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message reporting.v1.ReportEntryConfig
 */
export const ReportEntryConfig = new ReportEntryConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TitlePageConfig$Type extends MessageType<TitlePageConfig> {
    constructor() {
        super("reporting.v1.TitlePageConfig", [
            { no: 1, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "subtitle", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "logo", kind: "scalar", opt: true, T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message reporting.v1.TitlePageConfig
 */
export const TitlePageConfig = new TitlePageConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReportConfig$Type extends MessageType<ReportConfig> {
    constructor() {
        super("reporting.v1.ReportConfig", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "title_page", kind: "message", T: () => TitlePageConfig },
            { no: 3, name: "entries", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ReportEntryConfig }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message reporting.v1.ReportConfig
 */
export const ReportConfig = new ReportConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReportScheduleDatetime$Type extends MessageType<ReportScheduleDatetime> {
    constructor() {
        super("reporting.v1.ReportScheduleDatetime", [
            { no: 1, name: "month_of_year", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "day_of_month", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "hour_of_day", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "minute_of_hour", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "timezone", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message reporting.v1.ReportScheduleDatetime
 */
export const ReportScheduleDatetime = new ReportScheduleDatetime$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReportScheduleSendOnce$Type extends MessageType<ReportScheduleSendOnce> {
    constructor() {
        super("reporting.v1.ReportScheduleSendOnce", [
            { no: 1, name: "time", kind: "message", T: () => ReportScheduleDatetime }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message reporting.v1.ReportScheduleSendOnce
 */
export const ReportScheduleSendOnce = new ReportScheduleSendOnce$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReportScheduleDaily$Type extends MessageType<ReportScheduleDaily> {
    constructor() {
        super("reporting.v1.ReportScheduleDaily", [
            { no: 1, name: "monday_to_friday_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "start_time", kind: "message", T: () => ReportScheduleDatetime },
            { no: 3, name: "end_time", kind: "message", T: () => ReportScheduleDatetime }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message reporting.v1.ReportScheduleDaily
 */
export const ReportScheduleDaily = new ReportScheduleDaily$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReportScheduleWeekly$Type extends MessageType<ReportScheduleWeekly> {
    constructor() {
        super("reporting.v1.ReportScheduleWeekly", [
            { no: 2, name: "start_time", kind: "message", T: () => ReportScheduleDatetime },
            { no: 3, name: "end_time", kind: "message", T: () => ReportScheduleDatetime }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message reporting.v1.ReportScheduleWeekly
 */
export const ReportScheduleWeekly = new ReportScheduleWeekly$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReportScheduleMonthly$Type extends MessageType<ReportScheduleMonthly> {
    constructor() {
        super("reporting.v1.ReportScheduleMonthly", [
            { no: 1, name: "send_on_last_day_of_month", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "start_time", kind: "message", T: () => ReportScheduleDatetime },
            { no: 3, name: "end_time", kind: "message", T: () => ReportScheduleDatetime }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message reporting.v1.ReportScheduleMonthly
 */
export const ReportScheduleMonthly = new ReportScheduleMonthly$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReportScheduleNever$Type extends MessageType<ReportScheduleNever> {
    constructor() {
        super("reporting.v1.ReportScheduleNever", []);
    }
}
/**
 * @generated MessageType for protobuf message reporting.v1.ReportScheduleNever
 */
export const ReportScheduleNever = new ReportScheduleNever$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReportSchedule$Type extends MessageType<ReportSchedule> {
    constructor() {
        super("reporting.v1.ReportSchedule", [
            { no: 1, name: "once", kind: "message", oneof: "interval", T: () => ReportScheduleSendOnce },
            { no: 2, name: "daily", kind: "message", oneof: "interval", T: () => ReportScheduleDaily },
            { no: 3, name: "weekly", kind: "message", oneof: "interval", T: () => ReportScheduleWeekly },
            { no: 4, name: "monthly", kind: "message", oneof: "interval", T: () => ReportScheduleMonthly },
            { no: 5, name: "never", kind: "message", oneof: "interval", T: () => ReportScheduleNever }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message reporting.v1.ReportSchedule
 */
export const ReportSchedule = new ReportSchedule$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReportDeliveryConfig$Type extends MessageType<ReportDeliveryConfig> {
    constructor() {
        super("reporting.v1.ReportDeliveryConfig", [
            { no: 1, name: "email_subject", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "email_body", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "email_reply_to_address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "recipient_email_addresses", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "owner_email_address", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message reporting.v1.ReportDeliveryConfig
 */
export const ReportDeliveryConfig = new ReportDeliveryConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduledReport$Type extends MessageType<ScheduledReport> {
    constructor() {
        super("reporting.v1.ScheduledReport", [
            { no: 1, name: "config", kind: "message", T: () => ReportConfig },
            { no: 2, name: "schedule", kind: "message", T: () => ReportSchedule },
            { no: 3, name: "delivery", kind: "message", T: () => ReportDeliveryConfig }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message reporting.v1.ScheduledReport
 */
export const ScheduledReport = new ScheduledReport$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GenerateReportRequest$Type extends MessageType<GenerateReportRequest> {
    constructor() {
        super("reporting.v1.GenerateReportRequest", [
            { no: 1, name: "config", kind: "message", T: () => ReportConfig }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message reporting.v1.GenerateReportRequest
 */
export const GenerateReportRequest = new GenerateReportRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GenerateReportResponse$Type extends MessageType<GenerateReportResponse> {
    constructor() {
        super("reporting.v1.GenerateReportResponse", [
            { no: 1, name: "pdf", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message reporting.v1.GenerateReportResponse
 */
export const GenerateReportResponse = new GenerateReportResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateScheduledReportRequest$Type extends MessageType<CreateScheduledReportRequest> {
    constructor() {
        super("reporting.v1.CreateScheduledReportRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "report", kind: "message", T: () => ScheduledReport },
            { no: 3, name: "send_now", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message reporting.v1.CreateScheduledReportRequest
 */
export const CreateScheduledReportRequest = new CreateScheduledReportRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateScheduledReportResponse$Type extends MessageType<CreateScheduledReportResponse> {
    constructor() {
        super("reporting.v1.CreateScheduledReportResponse", [
            { no: 1, name: "report_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message reporting.v1.CreateScheduledReportResponse
 */
export const CreateScheduledReportResponse = new CreateScheduledReportResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateScheduledReportRequest$Type extends MessageType<UpdateScheduledReportRequest> {
    constructor() {
        super("reporting.v1.UpdateScheduledReportRequest", [
            { no: 1, name: "report_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "new_report", kind: "message", T: () => ScheduledReport }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message reporting.v1.UpdateScheduledReportRequest
 */
export const UpdateScheduledReportRequest = new UpdateScheduledReportRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateScheduledReportResponse$Type extends MessageType<UpdateScheduledReportResponse> {
    constructor() {
        super("reporting.v1.UpdateScheduledReportResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message reporting.v1.UpdateScheduledReportResponse
 */
export const UpdateScheduledReportResponse = new UpdateScheduledReportResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteScheduledReportRequest$Type extends MessageType<DeleteScheduledReportRequest> {
    constructor() {
        super("reporting.v1.DeleteScheduledReportRequest", [
            { no: 1, name: "report_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message reporting.v1.DeleteScheduledReportRequest
 */
export const DeleteScheduledReportRequest = new DeleteScheduledReportRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteScheduledReportResponse$Type extends MessageType<DeleteScheduledReportResponse> {
    constructor() {
        super("reporting.v1.DeleteScheduledReportResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message reporting.v1.DeleteScheduledReportResponse
 */
export const DeleteScheduledReportResponse = new DeleteScheduledReportResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetScheduledReportRequest$Type extends MessageType<GetScheduledReportRequest> {
    constructor() {
        super("reporting.v1.GetScheduledReportRequest", [
            { no: 1, name: "report_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message reporting.v1.GetScheduledReportRequest
 */
export const GetScheduledReportRequest = new GetScheduledReportRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetScheduledReportResponse$Type extends MessageType<GetScheduledReportResponse> {
    constructor() {
        super("reporting.v1.GetScheduledReportResponse", [
            { no: 1, name: "report", kind: "message", T: () => ScheduledReport }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message reporting.v1.GetScheduledReportResponse
 */
export const GetScheduledReportResponse = new GetScheduledReportResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListReportsItem$Type extends MessageType<ListReportsItem> {
    constructor() {
        super("reporting.v1.ListReportsItem", [
            { no: 1, name: "report_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "report_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "report_email_addresses", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "last_sent_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message reporting.v1.ListReportsItem
 */
export const ListReportsItem = new ListReportsItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListScheduledReportsRequest$Type extends MessageType<ListScheduledReportsRequest> {
    constructor() {
        super("reporting.v1.ListScheduledReportsRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message reporting.v1.ListScheduledReportsRequest
 */
export const ListScheduledReportsRequest = new ListScheduledReportsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListScheduledReportsResponse$Type extends MessageType<ListScheduledReportsResponse> {
    constructor() {
        super("reporting.v1.ListScheduledReportsResponse", [
            { no: 1, name: "reports", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ListReportsItem }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message reporting.v1.ListScheduledReportsResponse
 */
export const ListScheduledReportsResponse = new ListScheduledReportsResponse$Type();
/**
 * @generated ServiceType for protobuf service reporting.v1.ReportingService
 */
export const ReportingService = new ServiceType("reporting.v1.ReportingService", [
    { name: "GenerateReport", options: {}, I: GenerateReportRequest, O: GenerateReportResponse },
    { name: "CreateScheduledReport", options: {}, I: CreateScheduledReportRequest, O: CreateScheduledReportResponse },
    { name: "UpdateScheduledReport", options: {}, I: UpdateScheduledReportRequest, O: UpdateScheduledReportResponse },
    { name: "DeleteScheduledReport", options: {}, I: DeleteScheduledReportRequest, O: DeleteScheduledReportResponse },
    { name: "GetScheduledReport", options: {}, I: GetScheduledReportRequest, O: GetScheduledReportResponse },
    { name: "ListScheduledReports", options: {}, I: ListScheduledReportsRequest, O: ListScheduledReportsResponse }
]);
